module.exports = __webpack_public_path__ + "static/tcc-logo-flat-fc879d3731e6d107816018e97a7edbc1.png";